import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box } from "@mui/material";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { NetworkManager } from "../../Components/NetworkManager";
import { CommonUtil } from "../../utils/CommonUtil";
import ToastManager from "../../Components/ToastManager";

const btnStyle = { marginTop: 10 };
const NewLinksDialogue = ({
  newLinkDialogue,
  onCancelDialogue,
  setLinksList,
  saveLoadData,
  openEditData,
}: any) => {
  const initialValues = {
    topicTitle: openEditData?.payload || "",
    mmeLink: openEditData?.mmeLink || "",
    ctaMessage: "",
  };
  const validationSchema = Yup.object().shape({
    topicTitle: Yup.string().required("Title Name is Required."),
  });
  const fbPageInfo: any = localStorage.getItem("fbPageDetail");
  const recFbPageInfp = JSON.parse(fbPageInfo)?.facebook;

  const onHandleSave = (values: any) => {
    if (openEditData) {
      const updatedLinks = (prevLinks: any) =>
        prevLinks.map((link: any) =>
          link.payload === openEditData.payload
            ? { ...link, payload: values.topicTitle }
            : link
        );
      setLinksList(updatedLinks);
    } else {
      const { topicTitle } = values;
      const fbPageInfo: any = localStorage.getItem("fbPageDetail");
      const recFbPageInfp = JSON.parse(fbPageInfo)?.facebook;
      let generatedLink = "";
      if (fbPageInfo) {
        const recFbPageInfp = JSON.parse(fbPageInfo)?.facebook;
        generatedLink = `https://m.me/rn/${
          recFbPageInfp?.fbPageId
        }?topic=${topicTitle}&${`cadence=daily`}`;
      }
      console.log(recFbPageInfp?.fbAccountId);

      const outputData = {
        attachment: {
          type: "template",
          payload: {
            template_type: "notification_messages",
            title: topicTitle,
            payload: topicTitle,
          },
        },
      };
      const path = "marketingMessages/saveOptinTemplate";
      let params = `pageId=${recFbPageInfp?.fbPageId}&optinTrigger=referral_link&rnTopic=${topicTitle}&mMeLink=${generatedLink}&payload=${topicTitle}`;

      try {
        NetworkManager.sendJsonRequest(
          path,
          outputData,
          params,
          "POST",
          true,
          (data: any) => onSuccessOptinCall(data, generatedLink, topicTitle),
          onErrorCall
        );
      } catch (error) {
        console.log(error);
      }
    }
  };
  const onSuccessOptinCall = (
    data: any,
    generatedLink: string,
    topicTitle: string
  ) => {
    var respData = CommonUtil.parseData(data);
    if (respData?.statusCode === "MKM0000") {
      setLinksList((prevLinks: any) => [
        ...prevLinks,
        {
          payload: topicTitle,
          mmeLink: generatedLink,
        },
      ]);
      ToastManager.showToast("M.me Link Created Successfully", "Success");
      saveLoadData();
    } else if (respData.statusCode === "MKM0002")
      ToastManager.showToast(
        "Error occurred while saving the Optin Request!",
        "Error"
      );
    else if (respData.statusCode === "MKM0010")
      ToastManager.showToast("RnTopic already exists for the PageId!", "Error");
  };
  const onErrorCall = (err: any) => {};
  const onSubmit = (values: any, props: any) => {
    onHandleSave(values);
    props.resetForm();
  };
  const handleClose = () => {
    onCancelDialogue();
  };
  return (
    <>
      <div>
        <Dialog
          open={newLinkDialogue}
          slotProps={{
            paper: {
              sx: {
                width: "80%",
                maxHeight: 600,
              },
            },
          }}>
          <DialogTitle className="text-center">
            {openEditData ? "Register Topic" : "Create M.me Link"}
          </DialogTitle>
          <DialogContent>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}>
              {(props) => (
                <Form>
                  <Box>
                    <Box>
                      <Field
                        as={TextField}
                        name="topicTitle"
                        label="Topic Title"
                        error={
                          props.errors.topicTitle && props.touched.topicTitle
                        }
                        helpertext={<ErrorMessage name="topicTitle" />}
                        required
                        value={props.values.topicTitle}
                        size="small"
                        disabled={openEditData ? true : false}
                        sx={{
                          height: 40,
                          margin: 2,
                          width: "94%",
                        }}
                      />
                      {openEditData && (
                        <Field
                          as={TextField}
                          name="mmeLink"
                          label="M.me Link"
                          error={props.errors.mmeLink && props.touched.mmeLink}
                          helpertext={<ErrorMessage name="mmeLink" />}
                          required
                          value={props.values.mmeLink}
                          size="small"
                          disabled={openEditData ? true : false}
                          sx={{
                            height: 40,
                            margin: 2,
                            width: "94%",
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                  {openEditData ? (
                    <Button
                      onClick={() => {
                        const link = `https://m.me/${recFbPageInfp?.fbPageId}?ref=Register%2B${props.values.topicTitle}`;
                        // window.location.href = link;
                        window.open(link, "_blank");
                        console.log(
                          `https://m.me/${recFbPageInfp?.fbPageId}?ref=Register%2B${props.values.topicTitle}`
                        );
                      }}
                      style={btnStyle}
                      sx={{ fontSize: "16px", ml: 2 }}>
                      Register
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      style={btnStyle}
                      sx={{ fontSize: "16px" }}>
                      Create
                    </Button>
                  )}
                  <Button
                    style={btnStyle}
                    sx={{ fontSize: "16px", ml: 2 }}
                    onClick={handleClose}>
                    Cancel
                  </Button>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};
export default NewLinksDialogue;
